import WithDirection from "../../../settings/withDirection";
import styled from "styled-components";
import Color from "../../../assets/Color";

const CustomPageStyle = styled.div`
  /* */

  width: 100%;  

  .ant-alert-warning, .ant-alert-error {
    display: flex;
    align-items: center;

    .ant-alert-icon{
      top: inherit !important;
    }
    .ant-alert-description{
      padding-left: 10px;
    }
    .ant-alert-message {
      margin-bottom: 0
    }
  }

  .row-detail {
    padding-bottom: 20px;
    display: flex;
    justify-content: space-between; 
    
    .button-group {
      text-align: right;
      margin-bottom: 15px;
    }
  }

  .width50 {
    width: 50%;
  }

  .buttonBottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: ${Color.White};
    padding: 20px;
    text-align: center;
    z-index: 100;
    -webkit-box-shadow: 0px 0px 15px #cbc9c9;
    -moz-box-shadow: 0px 0px 15px #cbc9c9;
    box-shadow: 0px 0px 15px #cbc9c9;
  }

  .justify-center {
    justify-content: center;
  }
  
  .isoImgWrapper {
    width: fit-content;
    height: 20px;

    img {
      width: 80px !important;
      object-fit: cover;
    }
  }
`;
export default WithDirection(CustomPageStyle);
